export default "__VITE_ASSET__5d2ba02b__"